export interface Option {
    name: string;
    value: string;
}

export interface Options {
    value: string | number | null;
    label: string;
}
export interface OptionsId {
    id: number;
    value: string;
    label: string;
}


export interface OptionsNum {
    value: number;
    label: string;
}

export const optionsAvailableType = [
    {value: '1', label: 'Доступно всем' },
    {value: '0', label: 'Выбранным студентам/группам'},
];



export const optionsLanguage: OptionsId[] = [
    {id: 0, value: 'A0', label: 'A0'},
    {id: 1, value: 'A1', label: 'A1'},
    {id: 2, value: 'A2', label: 'A2'},
    {id: 3, value: 'B1', label: 'B1'},
    {id: 4, value: 'B2', label: 'B2'},
    {id: 5, value: 'C1', label: 'C1'},
    {id: 6, value: 'C2', label: 'C2'},
];


export const optionsTimeMinutes: OptionsNum[] = [
    { value: 10, label: '10' },
    { value: 15, label: '15' },
    { value: 20, label: '20' },
    { value: 25, label: '25' },
    { value: 30, label: '30' },
];


export const optionsAddTest: Options[] = [
    {value: 'тест 1', label: 'Тест 1'},
    {value: 'тест 2', label: 'Тест 2'},
    {value: 'тест 3', label: 'Тест 3'},
    {value: 'тест 4', label: 'Тест 4'},
];


export const optionsTextOfQuestion:  Options[] = [
    {value: 'withoutSkipping', label: 'Без пропусков'},
    {value: 'singleSpaced', label: 'С одним пропуском'},
    {value: 'doublePassed', label: 'С двумя пропусками'},
    {value: 'determineProcedure', label: 'Определить порядок'},
];

export const optionsResponseType:  Options[] = [
    {value: 'withoutSkipping', label: 'Текстовые ответы'},
    {value: 'determineProcedure', label: 'Определить порядок'},
];

// {value: 'textResponses', label: 'Текстовые ответы'},
